import { InputHTMLAttributes } from "react";

export interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  dataTyp?: string;
  labelFor?: string;
  styles?: string;
  updateAble?: string;
}

export default function Cell({
  label,
  name,
  type = "text",
  value,
  labelFor = "",
  disabled,
  dataTyp = "R",
  updateAble = "false",
  styles,
  ...rest
}: IProps) {
  return (
    <>
      <label htmlFor={labelFor}>{label}</label>
      <input
        type={type}
        name={name}
        defaultValue={value}
        className={styles}
        data-type={dataTyp}
        data-update={updateAble}
        autoComplete="off"
        onFocus={(e) => {
          const { update } = e.currentTarget.dataset;
          if (update === "true") {
            e.currentTarget.setAttribute("data-type", "U");
          }
        }}
        disabled={disabled}
        {...rest}
      />
    </>
  );
}
